import { BaseDto } from "./base-dto";
export class rol extends BaseDto {
  public nombre!: string;
}
